<ng-container *ngIf="isAIEnabled$ | async">
	<ui-card *ngIf="!(isHidden$ | async)" [class]="uiCardClass">
		<ng-container card-content>
			<div class="flex justify-between items-center">
				<div class="flex gap-2 items-center justify-start">
					<div
						class="bg-opacity-20 bg-purple-300 flex items-center justify-center p-2 rounded"
					>
						<i-tabler class="text-purple-800" name="sparkles"></i-tabler>
					</div>
					<h5>Smart Document Processing with AI</h5>
				</div>
				<button
					class="flex items-center justify-center p-2 rounded self-start"
					aria-label="Close Smart Document Processing with AI Information"
					(click)="hideAiNotification()"
				>
					<i-tabler class="h-4 w-4" name="x"></i-tabler>
				</button>
			</div>
			<p>
				Our AI scans your documents and automatically fills in the required
				information for your matter, saving you time and reducing manual effort.
			</p>
		</ng-container>
	</ui-card>
</ng-container>
